var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup255(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_128",
    "data-name": "Rectangle 128",
    width: 34,
    height: 34,
    transform: "translate(-0.204 0.5)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_255",
    "data-name": "Group 255",
    transform: "translate(-983 -255)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_51",
    "data-name": "Ellipse 51",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(983 255)",
    fill: "#ee8b3f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_65",
    "data-name": "Group 65",
    transform: "translate(993.704 266)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58",
    transform: "translate(-3.5 -4.5)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M153.444,91.672a.848.848,0,0,0-.743-.14l-11.993,3.394a.849.849,0,0,0-.618.816v11.488a3.393,3.393,0,1,0,1.7,2.937V99.779l10.3-2.914v6.971a3.393,3.393,0,1,0,1.7,2.937V92.349a.849.849,0,0,0-.337-.677m-15.05,20.193a1.7,1.7,0,1,1,1.7-1.7,1.7,1.7,0,0,1-1.7,1.7m11.993-3.394a1.7,1.7,0,1,1,1.7-1.7,1.7,1.7,0,0,1-1.7,1.7m1.7-13.369-10.3,2.914v-1.63l10.3-2.914Z",
    transform: "translate(-122.353 -81.431)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M11.84,6.024A17.052,17.052,0,0,1,7.624,1.845L6.646.378a.848.848,0,0,0-1.554.47v13.3a3.393,3.393,0,1,0,1.7,2.937V3.587a20.035,20.035,0,0,0,4.048,3.806,2.546,2.546,0,0,1-1.5,4.6.849.849,0,1,0,0,1.7A4.243,4.243,0,0,0,11.84,6.024M3.394,18.781a1.7,1.7,0,1,1,1.7-1.7,1.7,1.7,0,0,1-1.7,1.7",
    transform: "translate(2.464 3.168)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup255);
export default __webpack_public_path__ + "static/media/Group255.de0e5384d753f3d046d43769cbe321fe.svg";
export { ForwardRef as ReactComponent };